export default __webpack_public_path__ + "static/media/heroBgSmall.f4ef3bd2.jpg";